import { render, staticRenderFns } from "./targetcollectiondtl.vue?vue&type=template&id=5460a24a&scoped=true"
import script from "./targetcollectiondtl.vue?vue&type=script&lang=js"
export * from "./targetcollectiondtl.vue?vue&type=script&lang=js"
import style0 from "./targetcollectiondtl.vue?vue&type=style&index=0&id=5460a24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460a24a",
  null
  
)

export default component.exports